import RecuperarPass from './RecuperarPass';
export default RecuperarPass;
